"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import useAuthInfo from "@/store/auth";
import { AjaxGet } from "@/util/Ajax";
import styles from "../discover.module.css";

const signInUrl = "/login?redirect=%2Fdiscover%2Fmanage";

export default function ManageListingClient() {
  const router = useRouter();
  const apiToken = useAuthInfo(state => state.apiToken);
  const [hydrated, setHydrated] = useState(false);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    void Promise.resolve(useAuthInfo.persist.rehydrate()).then(() => {
      if (active) setHydrated(true);
    });
    return () => { active = false; };
  }, []);

  useEffect(() => {
    if (!hydrated) return;
    if (!apiToken) { router.replace(signInUrl); return; }
    let active = true;
    setError("");
    void AjaxGet({ apiToken }, "Discover/MyListing").then(response => {
      if (!active) return;
      if (response?.data?.encryptedId) {
        router.replace(`/discover/${encodeURIComponent(response.data.encryptedId)}/admin`);
      } else if (response?.response?.status === 401) {
        router.replace(signInUrl);
      } else if (response?.response?.status === 400 && /No discovery listing found for user/i.test(response?.response?.data?.message || "")) {
        router.replace("/discover/create");
      } else {
        setError("Could not load your listing. Please try again.");
      }
    }).catch(() => {
      if (active) setError("Could not load your listing. Please try again.");
    });
    return () => { active = false; };
  }, [hydrated, apiToken, router, attempt]);

  return (
    <main className={styles.page}>
      <section className={styles.heroSection}>
        <div className={styles.container}>
          <div className={styles.hero}>
            <h1>Manage your listing</h1>
            {error ? <>
              <p role="alert">{error}</p>
              <div className={styles.heroActions}>
                <button type="button" className={styles.button} onClick={() => setAttempt(value => value + 1)}>Try again</button>
                <Link className={styles.secondary} href="/discover">Back to Discover</Link>
              </div>
            </> : <p role="status">Opening your listing…</p>}
          </div>
        </div>
      </section>
    </main>
  );
}
